import TransactionConstants from '@common/constants/TransactionConstants';
import { RenterPaymentHistoryInterface } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

const unpaidFailedRegex = `${TransactionConstants.STATUS.UNPAID}|${TransactionConstants.STATUS.PAYMENT_FAILED}`;

const unpaidOtpTransactionsFilter = (transactions) =>
  transactions
    .filter(({ paymentCategory = '' }) => paymentCategory === TransactionConstants.CATEGORY.ONE_TIME_PAYMENT)
    .filter(({ renterStatus = '' }) => renterStatus.match(new RegExp(unpaidFailedRegex)));

const convertTxDates = (transactions) =>
  transactions.map((transaction) => ({
    ...transaction,
    dueDate: formatTimestampToYMDString(transaction.dueDate),
    dateCreated: formatTimestampToYMDString(transaction.dateCreated),
    dateReceived: formatTimestampToYMDString(transaction.dateReceived),
    dateRequested: formatTimestampToYMDString(transaction.dateRequested),
  }));

export default (paymentHistory: RenterPaymentHistoryInterface[]) => {
  const { propertyId = '', transactions = [], lateRentPayments = [] } = paymentHistory[0] || {};
  const newTransactions = convertTxDates(transactions);
  const unpaidOtpTransactions = unpaidOtpTransactionsFilter(newTransactions);

  return {
    propertyId: propertyId && String(propertyId),
    transactions: newTransactions,
    lateRentPayments,
    unpaidOtpTransactions,
  };
};
